import logoLight from 'assets/logo-light.svg';
import logoDark from 'assets/logo-dark.svg';

import systemTheme from 'assets/images/system-theme.png';
import lightTheme from 'assets/images/light-theme.png';
import darkTheme from 'assets/images/dark-theme.png';

export { default as brokenImage } from 'assets/images/broken.png';
export { default as secureImage } from 'assets/images/secure.png';

export const logo = {
    light: logoLight,
    dark: logoDark,
};

export const themeImage = {
    system: systemTheme,
    light: lightTheme,
    dark: darkTheme,
};
